import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryWorkspacesArgs, BackendWorkspaceConnection } from 'src/types/backend';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const QUERY = gql`
  query WorkspaceAssociatedResources($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          associatedResources {
            ...PerformanceCenterCustomerResource
          }
        }
      }
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

type Variables = Pick<BackendQueryWorkspacesArgs, 'customerId' | 'id'>;

export const queryWorkspaceAssociatedResources = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<BackendWorkspaceConnection>(result.data);
  return data?.edges?.[0]?.node?.associatedResources ?? [];
};
